export default __webpack_public_path__ + "static/media/frontend.853ce66b.jpg";